import React from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import "./style.scss";
import PrimaryButton from "../../elements/primary-button";
import PrimaryLink from "../../elements/primary-link";
import classNames from "classnames";
import BodyText from "../../elements/body-text";

const MembershipNeedHelp = ({ needHelp }) => {
  const contentMargin = classNames("membership-need-help-content", {
    "qr-code": needHelp.qrCode
  });
  return (
    <div className="membership-need-help">
      <Heading type={needHelp?.heading?.type} html={needHelp?.heading?.html} typographyClass="type-h3" />
      <div className={contentMargin}>
        <div className="content-body">
          {needHelp.bodyApp?.value && <BodyText html={needHelp.bodyApp} className={"content-body-app"} />}
          {needHelp.openAppLink && (
            <div className="content-body-open-app-link">
              <PrimaryLink {...needHelp.openAppLink} />
            </div>
          )}
          {needHelp.bodyContactUs?.value && <BodyText html={needHelp.bodyContactUs} className={"content-body-contact-us body"} />}
        </div>
        {needHelp.qrCode && (
          <div className="content-qr">
            <img {...needHelp.qrCode} />
          </div>
        )}
      </div>
      <div className="membership-need-help-contact-us">
        <PrimaryButton {...needHelp.button} />
      </div>
      {needHelp.link && (
        <div className="membership-need-help-service">
          <PrimaryLink {...needHelp.link} />
        </div>
      )}
    </div>
  );
};

MembershipNeedHelp.propTypes = {
  needHelp: PropTypes.shape({
    heading: PropTypes.shape({
      title: PropTypes.string,
      body: PropTypes.string
    }),
    bodyApp: PropTypes.object,
    bodyContactUs: PropTypes.object,
    qrCode: PropTypes.object,
    button: PropTypes.object,
    openAppLink: PropTypes.object
  })
};

export default MembershipNeedHelp;
